'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FooterLink = exports.FooterLinks = exports.FooterText = exports.Footer = undefined;

var _footer = require('./footer');

var _footer2 = _interopRequireDefault(_footer);

var _footer_text = require('./footer_text');

var _footer_text2 = _interopRequireDefault(_footer_text);

var _footer_links = require('./footer_links');

var _footer_links2 = _interopRequireDefault(_footer_links);

var _footer_link = require('./footer_link');

var _footer_link2 = _interopRequireDefault(_footer_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Footer = _footer2.default;
exports.FooterText = _footer_text2.default;
exports.FooterLinks = _footer_links2.default;
exports.FooterLink = _footer_link2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/footer/index.js
// module id = 783
// module chunks = 0